import {i18n} from '@online-offer/i18n';
import {
  Box,
  Center,
  getValueByDevice,
  Heading,
  Hide,
  HStack,
  Image,
  Show,
  Space,
  Text,
  useDevice,
  VStack,
} from 'platform/foundation';

import {APPLICATION_NAME} from '../../consts/applicationName';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {getWorkspaceCustomization} from '../../utils/getWorkspaceCustomization';
import {makeStorageResizeUrl} from '../../utils/makeStorageResizeUrl';
import {Button} from '../Button/Button';
import {ButtonIcon} from '../ButtonIcon/ButtonIcon';

// we're multiplying by 2 for larger screens to have better quality
const LOGO_WIDTH = 220 * 2;
const LOGO_HEIGHT = 44 * 2;

export function Navigation() {
  const {logo: applicationLogo} = getWorkspaceCustomization();
  const {activeReservation, customer, vehicle, tenantLogoUrl} = useGetOnlineOfferData();

  const device = useDevice();

  const customerName = activeReservation?.customer?.name ?? customer;

  const resizedLogoUrl = tenantLogoUrl
    ? makeStorageResizeUrl(tenantLogoUrl, {
        width: LOGO_WIDTH,
        height: LOGO_HEIGHT,
        withoutEnlargement: true,
      })
    : undefined;

  const onShare = () =>
    navigator.share({
      title: `${vehicle?.title} • ${APPLICATION_NAME}`,
      url: window.location.href,
    });

  return (
    <>
      <Box
        position={getValueByDevice(device, 'sticky', 'static', 'static', 'static')}
        top={0}
        backgroundColor="general.white"
        zIndex="MENU_BAR"
        data-testid="navigationContainer"
      >
        <Center justify="center" width="100%">
          <Box
            flexGrow={1}
            maxWidth={432}
            paddingTop={[2, 4, 4, 6]}
            paddingBottom={[0, 4, 4, 6]}
            paddingHorizontal={[3, 8, 8, 20]}
          >
            <HStack align="center" justify="space-between">
              <Box>
                {resizedLogoUrl ? <Image maxHeight={11} src={resizedLogoUrl} /> : applicationLogo}
              </Box>
              <Hide onMobile>
                <Box paddingLeft={8}>
                  <VStack>
                    <Text size="small" color="secondary">
                      {i18n.t('navigation.offerFor', {
                        code: activeReservation?.businessCase?.code ?? '',
                      })}
                    </Text>
                    <Heading size={4}>{customerName}</Heading>
                  </VStack>
                </Box>
              </Hide>
              <Space horizontal={4} fillAvailable />
              <HStack spacing={2}>
                <Show when={navigator.share}>
                  <Show onMobile>
                    <ButtonIcon
                      data-testid="shareButton"
                      variant="outline"
                      icon="share"
                      onClick={onShare}
                      size="small"
                    />
                  </Show>
                  <Hide onMobile>
                    <Button
                      data-testid="shareButton"
                      variant="outline"
                      title={i18n.t('share')}
                      leftIcon="share"
                      onClick={onShare}
                    />
                  </Hide>
                </Show>
              </HStack>
            </HStack>
            <Show onMobile>
              <Box paddingTop={3}>
                <Show onMobile>
                  <VStack>
                    <Text size="small" color="secondary">
                      {i18n.t('navigation.offerFor', {
                        code: activeReservation?.businessCase?.code ?? '',
                      })}
                    </Text>
                    <Heading size={4}>{customerName}</Heading>
                  </VStack>
                </Show>
              </Box>
            </Show>
          </Box>
        </Center>
      </Box>
    </>
  );
}
